import SportOnboarding from "./components/SportOnboarding";
import { runningConfig } from "./ch/sportConfig";

const Running = () => {
  return <SportOnboarding sportConfig={runningConfig} navKey="running" />;
};

export default Running;
